<template>
    <div>

        <b-container>
            <b-row>
                <b-col><div style='margin-top:20px'><h2>Welcome To Keg Seeker</h2></div>
                </b-col>
            </b-row>
            <b-row><hr></b-row>
            <b-row>
                <h5>
                    Start by finding some beers from the <router-link to="allbeers" >FIND BEERS</router-link> page
                </h5>
            </b-row>
            <b-row><hr></b-row>
            <b-row>
                <h5>
                    Check out the <router-link to="faq" >FAQ</router-link> page to learn more about how Keg Seeker works
                </h5>
            </b-row>

            <b-row><hr></b-row>
            <b-row>
                <b-button variant="outline-primary"><router-link to="allbeers" > Continue to Find Beers</router-link></b-button>
            </b-row>
            <b-row><hr></b-row>
            

        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
import Pagefooter from './Pagefooter'
    export default {
    components: {
            Pagefooter,
        },
        
    }
</script>